import { PARAMETERS_REFRESH_INTERVAL_SECONDS } from 'config';
import React, { useCallback, useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import { isEmpty } from 'lodash-es';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';
import { SECONDS } from 'utils';
import { EParametersActionType, useDynamicParametersDispatch } from './DynamicParametersContext';

export const DynamicParametersRefresher: React.FC = () => {
  const dispatchDynamicParameters = useDynamicParametersDispatch();

  const refreshDynamicParameters = useCallback(async () => {
    try {
      const newDynamicParameters = await ParameterService.fetchParameters();

      if (isEmpty(newDynamicParameters)) {
        return;
      }

      dispatchDynamicParameters?.({ type: EParametersActionType.SET_PARAMETERS, value: newDynamicParameters });
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [dispatchDynamicParameters]);

  useEffect(() => {
    refreshDynamicParameters();
    const intervalId = setInterval(refreshDynamicParameters, PARAMETERS_REFRESH_INTERVAL_SECONDS * SECONDS);

    return () => clearInterval(intervalId);
  }, [refreshDynamicParameters]);

  return null;
};
